export default __webpack_public_path__ + "static/808cjk-2736255fe8a9578bda223ea5acfa2e64.jpg";